import { SaveButton } from "components/Buttons"
import Table from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Row, Col, Input } from "reactstrap"
import { getNotifications } from "store/actions"
import notificationsListColumns from "./notificationsListColums"
import { URL_PATHS } from "constants/index"

const Notifications = ({
  loading,
  notifications,
  getNotifications,
  handleDelete,
  history,
  handleSend,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "title",
    od: "asc",
  })

  useEffect(() => {
    getNotifications({ ...defaultOrder, page: 1, type: "notifications" })
  }, [])

  const actions = [
    {
      name: "Edit",
      onClick: item => {
        history.push(`/communication/${item.id}`)
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: item => {
        handleDelete(item)
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
    {
      name: "Send Now",
      onClick: item => {
        handleSend(item)
      },
      icon: "bx bx-send",
      isAvailable: true,
    },
  ]

  const handlePageChange = page => {
    getNotifications({
      page: page,
      ...defaultOrder,
      type: "notifications",
      ...(showResetButton ? { s: searchValue } : {}),
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getNotifications({
      o: sortField,
      od: sortOrder,
      page: 1,
      type: "notifications",
      ...(showResetButton ? { s: searchValue } : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const handleSearch = () => {
    if (searchValue.trim().length) {
      getNotifications({
        ...defaultOrder,
        page: 1,
        type: "notifications",
        s: searchValue,
      })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    getNotifications({
      ...defaultOrder,
      type: "notifications",
    })
    setSearchValue("")
    setShowResetButton(false)
  }

  return (
    <React.Fragment>
      <Row className={"my-2  d-flex justify-content-end"}>
        <Col xs={12} sm={5} md={4} xl={2} className={"mb-2"}>
          <Link to={URL_PATHS.ADD_NOTIFICATION}>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Add Notification"
            />
          </Link>
        </Col>
      </Row>
      <Row className={"my-3"}>
        <Col sm={6} md={5} xl={4} className="my-1">
          <Input
            value={searchValue}
            onChange={event => {
              setSearchValue(event.target.value)
            }}
            placeholder="Search"
          />
        </Col>
        <Col xs={6} sm={2} xl={1} className="my-1">
          <SaveButton
            type="button"
            fullWidth={true}
            content="Search"
            onClick={handleSearch}
          />
        </Col>
        {showResetButton && (
          <Col xs={6} sm={2} xl={1} className="my-1">
            <SaveButton
              fullWidth={true}
              type="button"
              content="Reset"
              color="light"
              onClick={handleResetSearch}
            />
          </Col>
        )}
      </Row>
      <Row className={"my-3"}>
        <Col>
          <Table
            columns={notificationsListColumns()}
            data={notifications?.data}
            loadingData={loading}
            actions={actions}
            paginationData={{
              current_page: notifications?.current_page,
              last_page: notifications?.last_page,
              total_items: notifications?.total,
              items_per_page: notifications?.per_page,
              from: notifications?.from,
              to: notifications?.to,
            }}
            onPageChange={handlePageChange}
            onTableSort={handleSort}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.Communications.loading,
  notifications: state.Communications.notifications,
})

const mapDispatchToProps = dispatch => ({
  getNotifications: values => dispatch(getNotifications(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Notifications))
